import { DefaultTheme } from 'styled-components';

import { ValueOf } from '../lib/interfaces/utils';

export const YACHT_STATUS = {
	Delivered: 'Delivered',
	PreDelivery: 'Pre-delivery',
	InProduction: 'In-production',
} as const;

export type YACHT_STATUS = ValueOf<typeof YACHT_STATUS>;

export const YACHT_STATUS_LABELS: Record<YACHT_STATUS, string> = {
	[YACHT_STATUS.InProduction]: 'D.gree commissioning',
	[YACHT_STATUS.PreDelivery]: 'Shipyard production',
	[YACHT_STATUS.Delivered]: 'Customer delivered',
};

export const YACHT_STATUS_OPTIONS = [
	{ value: '', label: 'All statuses' },
	{ value: YACHT_STATUS.InProduction, label: YACHT_STATUS_LABELS[YACHT_STATUS.InProduction] },
	{ value: YACHT_STATUS.PreDelivery, label: YACHT_STATUS_LABELS[YACHT_STATUS.PreDelivery] },
	{ value: YACHT_STATUS.Delivered, label: YACHT_STATUS_LABELS[YACHT_STATUS.Delivered] },
];

export const getYachtStatusColor = (status: YACHT_STATUS, theme: DefaultTheme): string => {
	switch (status) {
		case YACHT_STATUS.Delivered:
			return theme.colors.success;
		case YACHT_STATUS.InProduction:
			return theme.colors.warning;
		case YACHT_STATUS.PreDelivery:
			return theme.text.colors.secondary;
		default:
			return theme.colors.neutral;
	}
};
